export default "__VITE_ASSET__60646dd5__"